let language = {
    "ADDRESS-BOOK-ALERT-DELETE-TITLE": "删除地址",
    "ADDRESS-BOOK-ALERT-DELETE-CONTENT": "确定删除该地址吗？",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-TITLE": "设置为默认地址",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-CONTENT": "您确定设置为默认地址吗？",
    "ADDRESS-BOOK-ALERT-DELETE-SELECT-TITLE": "删除项目",
    "ADDRESS-BOOK-ALERT-DELETE-SELECT-CONTENT": "未选择任何选定项目",
    "ADDRESS-BOOK-ALERT-DELETE-QUESTION": "您确定要删除地址吗？",
    "ADDRESS-BOOK-ALERT-DELETE-SUCCESS": "删除成功",
    "ADDRESS-BOOK-ALERT-SET-DEFAULT-SUCCESS": "设置默认地址成功",
};

export { language }